<template>
  <el-footer class="mobile-footer">
    <base-aside
      :defaultOpeneds="['产品']"
      mode="vertical"
      :active="$route.path"
      :routers="routers"
    >
    </base-aside>

    <div class="footer-list">
      <div class="footer-text">PÁGINAS LEGALES</div>
      <div class="links">
        <el-link @click="$router.push('/aviso')">Aviso legal</el-link>
        <el-link @click="$router.push('/cookies')">Política de cookies</el-link>
        <el-link @click="$router.push('/privacidad')"
          >Política de privacidad</el-link
        >
        <el-link @click="openPdf('5.4PolítiCadeCalidadYmedioAmbiente.pdf')"
          >Política de calidad y medio ambiente</el-link
        >
      </div>
      <div class="footer-text">CERTIFICADOS</div>
      <div class="flex justify-center">
        <el-link
          class="link-img"
          @click="openPdf('5.5CertificadoDOKCailidad.pdf')"
        >
          <img src="@/assets/img/footer4.png" />
        </el-link>
        <el-link
          class="link-img"
          @click="openPdf('5.6CertificadoDOKMedioAmbiente.pdf')"
        >
          <img src="@/assets/img/footer5.png" />
        </el-link>
        <el-link class="link-img">
          <img src="@/assets/img/footer6.jpg" />
        </el-link>
      </div>
    </div>
    <div class="logo-info">
      <img class="logo" src="@/assets/img/logo1.jpg" />
      <h4>MARAGON CONSTRUCCIÓN</h4>
      <div class="flex">
        
        <!-- <img src="@/assets/img/footer8.svg" /> -->
        <el-link href="tel:603440332"> 603 440 332</el-link>
      </div>
      <div class="flex">
        <!-- <img src="@/assets/img/footer7.svg" /> -->
        <el-link href="mailto:info@maragonconstruccion.es">
          info@maragonconstruccion.es
        </el-link>
      </div>
    </div>
  </el-footer>
</template>

<script>
import baseAside from "./aside"
export default {
  name: "mobileFooter",
  props: {
    routers: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  components: {
    baseAside,
  },
  methods: {
    openPdf(name) {
      window.open(`/${name}`)
    },
  },
}
</script>
<style lang="scss" scoped>
.el-footer.mobile-footer {
  padding-top: 70px;
  padding-bottom: 70px;
  height: auto !important;
  background: $--color-primary;
  .logo-info {
    margin-top: 60px;
    margin-bottom: 60px;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    .logo {
      width: 300px;
      height: 300px;
    }
    h4 {
      margin-top: 30px;
      margin-bottom: 30px;
      color: #fffffe;
      font-size: calc(var(--font-size) + 6px);
    }
    p,
    i {
      font-size: var(--font-size);
      color: #fffffe;
      opacity: 0.6;
    }
    p {
      margin-bottom: 10px;
    }
    i {
      margin-right: 20px;
    }
    .flex {
      align-items: center;
      img {
        width: 30px;
        height: 30px;
        margin-right: 10px;
      }
      .el-link {
        color: #fff;
      }
    }
  } 
  .footer-list {
    .footer-text {
      padding-top: $--padding;
      padding-bottom: $--padding;
      font-size: calc(var(--font-size) + 2px);
      color: rgba(#fff, 0.8);
      font-weight: bold;
      text-align: center;
    }
    .link-img {
      display: block;
      width: 200px;
      height: 200px;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .link-img + .link-img {
      margin-left: 20px;
    }
    .links {
      display: flex;
      flex-direction: column;
      .el-link {
        font-size: var(--font-size);
        color: #fff;
      }
    }
  }
}
</style>
